import FornecedorService from '../_services/FornecedorService'
import { erroArrayToString } from '@/utils/trataErroRetornoApi'
import { fornecedorModel } from '../_model/fornecedor'

const state = {
  loading: false,
  loadingStore: false,
  fornecedores: [],
  currentPage: null,
  urlFirstPage: null,
  urlNextPage: null,
  urlPrevPage: null,
  urlLastPage: null,
  urlPath: null,
  fornecedorSelecionado: undefined,
  erros: '',
  filter: null,
}

const getters = {
  GET_FORNECEDORES : (state) => state.fornecedores,
  GET_URL_PATH : (state) => state.urlPath,
  GET_ERROS: state => state.erros,
}

const mutations = {

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false
  },

  FORNECEDOR_SELECTED : (state, { fornecedor }) => {
    state.fornecedorSelecionado = Object.assign({}, fornecedor)
  },

  MERGE_PESSOA: (state, { pessoa }) => {
    var objOld = Object.assign({}, state.fornecedorSelecionado)
    objOld.pessoa = pessoa
    state.fornecedorSelecionado = Object.assign({}, objOld)
  },

  SET_FORNECEDORES : (state, { fornecedores }) => {
    state.fornecedores = JSON.parse(JSON.stringify(fornecedores))
    state.urlFirstPage = fornecedores.first_page_url
    state.urlPrevPage = fornecedores.prev_page_url
    state.urlPrevPage = fornecedores.prev_page_url
    state.urlLastPage = fornecedores.last_page_url
    state.urlPath = fornecedores.path
    state.currentPage = fornecedores.current_page
  },

  SET_FILTER: (state, filter) => {
    state.filter = filter
  },

  SET_ERROS : (state, erros) => {
    state.erros = erros.erros
  },

  ERASE_ERROS : (state) => {
    state.erros = ''
  },

  RESET_SELECTED : state => state.fornecedorSelecionado = undefined,

}

const actions = {

  GET_FORNECEDORES : async ({ commit, state }) => {
      commit('SET_FORNECEDORES', { fornecedores : []})
      commit('ERASE_ERROS')
      await FornecedorService.getFornecedores(state.filter)
      .then(response => {
        if (response.data.status) {
          commit('SET_FORNECEDORES', { fornecedores : response.data.fornecedores })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      })
  },

  PAGINATE_FORNECEDORES : async ({ commit }, url) => {
    commit('ERASE_ERROS')
    await FornecedorService.getPagination(url)
    .then(response => {
      if (response.data.status) {
        commit('SET_FORNECEDORES', { fornecedores : response.data.fornecedores })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
    })
  },

  GET_FORNECEDOR : async ({commit}, id) => {
    commit('ERASE_ERROS')
    await FornecedorService.getFornecedor(id)
    .then(response => {
      if (response.data.status) {
        commit('FORNECEDOR_SELECTED', { fornecedor : response.data.fornecedor })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
    })

  },

  GET_CPFCNPJ : async ({commit}, cpfcnpj) => {
    commit('ERASE_ERROS')
    if (!cpfcnpj) return
    await FornecedorService.getCpfCnpj(cpfcnpj)
    .then(response => {
      if (response.data.status) {
        var data = response.data
        if (data.fornecedor) {
          commit('FORNECEDOR_SELECTED', { fornecedor : response.data.fornecedor })
        } else if (data.pessoa) {
          commit('MERGE_PESSOA', { pessoa: data.pessoa })
        }
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
    })
  },

  STORE_FORNECEDOR : async ({ commit, dispatch }, fornecedor) => {
    commit('ERASE_ERROS')
    try {
      commit('SET_LOADING_STORE', true)
      if (!fornecedor.id || !(fornecedor.id > 0)) { 
        var response = await FornecedorService.postFornecedor(fornecedor)
      } else {
        var response = await FornecedorService.putFornecedor(fornecedor.id, fornecedor)
      }

      if (response.data.status) {
        commit('FORNECEDOR_SELECTED', { fornecedor : response.data.fornecedor })
        if (state.urlPrevPage || state.urlNextPage) {
          await dispatch('PAGINATE_FORNECEDORES', `${state.urlPath}?page=${state.currentPage}`)
        } else {
          await dispatch('GET_FORNECEDORES')
        }

      } else if (!response.data.status && response.data.validacao) {
        var erros = erroArrayToString(response.data.erros)
        commit('SET_ERROS', { erros: erros })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
    } finally {
      commit('SET_LOADING_STORE', false)
    }
  },

  DELETE_FORNECEDOR : async ({ commit, dispatch }, fornecedor) => {
    commit('ERASE_ERROS')
    try {
      var response = await FornecedorService.deleteFornecedor(fornecedor.id)

      if (response.data.status) {
        await dispatch('GET_FORNECEDORES')

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    }
  },

  FORNECEDOR_SELECTED : async ({dispatch, commit}, id) => { 
    if (id > 0) { 
      await dispatch('GET_FORNECEDOR', id)
    } else {
      var obj = new fornecedorModel.fornecedor()
      await commit('FORNECEDOR_SELECTED', { fornecedor: obj })
    }
  },

  RESET_SELECTED : ( {commit} ) => { commit('RESET_SELECTED') },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
} 


// WEBPACK FOOTER //
// ./src/views/Fornecedor/_store/index.js